import { useMediaQuery } from '@mui/material'
import { useContext, useEffect, useState } from 'react';
import gaiaTheme from '../../../../root-components/theme';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { UserDetailsContext } from '../../../../context/user-details/user-details';
import { IHeadCell } from '../../../../shared/interfaces/table-display.model';
import { TableDisplay } from '../../../presentation-components/miscellaneous-components/table-display';
import { useNavigate } from 'react-router-dom';
import ReportPeriodService from '../../../../shared/services/report-period/report-period.service';
import { IReportPeriod } from '../../../../shared/services/report-period/report-period.model';
import { LoadingPage } from '../../loading-page';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';

export const ReportingGhgReportPage = () => {
  const navigate = useNavigate();
  const reportPeriodService = new ReportPeriodService()
  const userDetailsContext = useContext(UserDetailsContext)
  const userDetails = userDetailsContext.userDetails
  const userNotificationsContext = useContext(UserNotificationsContext)
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
  const [selected, setSelected] = useState<string[]>([]);
  const [allReportPeriods, setAllReportPeriods] = useState<IReportPeriod[]>([]);
  const [inputPage, setInputPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  //Variables
  const companyName = (!userDetails?.isPartner && userDetails?.partnerOrganisation) || (userDetails?.isPartner && userDetails?.isLoggedInAsClient) ? userDetails?.partnerOrganisation?.partnerName : 'Gaia';

  useEffect(() => {
    reportPeriodService.getAllReportPeriodsWithReportDetailsPagination(`includeGhg=true`, inputPage, perPage)
      .then(response => {
        setIsLoading(false)
        setAllReportPeriods(response.rows)
        setTotalRecords(response.count);
      })
      .catch(err => console.log(err))
  }, [inputPage, perPage])

  // No Status column here: the GHG CSV is generated client-side and never records a
  // fileDownload row, so a derived status would read Not Started forever. The SECR and
  // Carbon Summary lists keep theirs because those reports do create tracked artefacts.
  const headCells: IHeadCell[] = [
    { id: 'reportPeriod', numeric: false, label: 'Report Period', sortable: false, isHeading: true },
  ];

  const rows = allReportPeriods.map(reportPeriod => {
    return {
      id: reportPeriod.id,
      reportPeriod: reportPeriod.friendlyName,
    }
  });

  const handleSelected = (selectedRowId: string[]) => {
    if (!userDetails?.organisation.subscriptionActive || (userDetails.organisation.subscriptionActive && userDetails.organisation.freeTrialDaysRemaining && userDetails.organisation.freeTrialDaysRemaining > 0)) {
      userNotificationsContext.openDialog({ active: true, hideCancelButton: true, title: 'Access Denied', message: `You must have a subscription to ${companyName} Carbon Accounting to be able to download your Greenhouse Gas Emissions Report.`, buttonCopy: 'Ok', })
    }
    else {
      if (selectedRowId[0] !== undefined) {
        navigate(`/reporting/greenhouse-gas-emissions-report/${selectedRowId[0]}`)
      }
    }
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title='Greenhouse Gas Emissions Report'
        includeBackButton={true}
        backButtonLink='/reporting'
        backButtonText='Back to reporting'
        hasTabs={false}
      />
      <LoadingPage pageReady={!isLoading}>
        {allReportPeriods &&
          <TableDisplay
            headCells={headCells}
            isMobileMode={isMobileMode}
            rows={rows}
            handleSelected={handleSelected}
            selected={selected}
            setSelected={setSelected}
            inputPage={inputPage}
            setInputPage={setInputPage}
            totalRecords={totalRecords}
            perPage={perPage}
            setPerPage={setPerPage} />
        }
      </LoadingPage>
    </PageOuterContainer>)
}